export const useSelectedConfigTab = () => {
	const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';

	const getSelectedConfigTab = () => localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
	const setSelectedConfigTab = (newConfigTab: string) =>
		localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);

	return { getSelectedConfigTab, setSelectedConfigTab };
};
